export default "__VITE_ASSET__78d0d6b9__"